import React from "react";
import { FaInstagram } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";

export default function Header() {
  return (
    <div>
      <div class="z-30 fixed top-[18px] pl-12 h-[42px] flex items-center">
        <span class="text-primary text-base">susan ma events</span>
      </div>
      <div class="z-30 fixed top-[18px] right-0 pr-12 h-[42px] flex items-center">
        <a href="mailto:susanmaevents@gmail.com">
          <MdOutlineEmail class="mr-2 text-xl text-primary" />
        </a>
        <a href="https://www.instagram.com/susanmaevents/">
          <FaInstagram class="text-xl text-primary" />
        </a>
      </div>
    </div>
  );
}
